import React from 'react';
import { motion } from 'framer-motion';
import { criteria } from '../../data/strategy';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
export function CriteriaSlide() {
  return <SlideFrame marker="Step 01 — Prescription criteria" data-id="element-74" data-mp="1vcc5g38zwmt3">
      <SlideTitle sub="Everything downstream is weighted by this ranking. A gap on criterion one is worth several gaps on criterion five." data-id="element-75" data-mp="1v9pnrase4qx5">
        What decides the script — in the HCP’s order
      </SlideTitle>

      <div className="mt-[4vh] flex min-h-0 flex-1 flex-col justify-center" data-id="element-76" data-mp="2nyn6tg4ferqy">
        <ul className="flex flex-col gap-[1.6vh]" data-id="element-77" data-mp="2s19z1i50eeoo">
          {criteria.map((criterion, index) => <li key={criterion.id} className="flex items-center gap-[2%]" data-id="element-78" data-mp="2e21vkd1tckeo" data-mpi={index}>
              <span className="w-[5%] font-display text-[clamp(17px,2.3vw,38px)] leading-none text-ink-mute" data-id="element-79" data-mp="2j03f0z35ilqo">
                {criterion.rank}
              </span>
              <span className="w-[24%] text-[clamp(12px,1.45vw,24px)] font-semibold leading-tight text-ink" data-id="element-80" data-mp="17mr8uhjx5r1c">
                {criterion.label}
              </span>
              <span className="w-[22%] text-[clamp(10px,1.1vw,17px)] text-ink-mute" data-id="element-81" data-mp="2m92p3hyh5zmt">
                {criterion.note}
              </span>
              <div className="relative h-[clamp(10px,1.5vw,24px)] flex-1 rounded-full bg-paper-tint" data-id="element-82" data-mp="2w5p8s3f2ekn9">
                <motion.span className="absolute inset-y-0 left-0 rounded-full bg-gapAccent" initial={{
              width: 0
            }} animate={{
              width: `${criterion.importance}%`
            }} transition={{
              duration: 0.28,
              delay: 0.04 * index,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-83" data-mp="2r5te4us9c5kd" />
              </div>
              <span className="w-[9%] text-right font-display text-[clamp(14px,1.9vw,32px)] leading-none text-ink" data-id="element-84" data-mp="39x4336efa89m">
                {criterion.importance}
              </span>
            </li>)}
        </ul>

        <p className="mt-[3.5vh] max-w-[70ch] border-t border-ink-line pt-[2vh] text-[clamp(10px,1.12vw,18px)] leading-[1.5] text-ink-soft" data-id="element-85" data-mp="3jsnjslkf10ds">
          Index of stated influence on the prescribing decision, 0–100, from
          qual with 15 prescribers followed by quant with ~150.
        </p>
      </div>
    </SlideFrame>;
}